import { render, staticRenderFns } from "./PetsAllowedIconComp.vue?vue&type=template&id=b9d536bc&"
import script from "./PetsAllowedIconComp.vue?vue&type=script&lang=js&"
export * from "./PetsAllowedIconComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9d536bc')) {
      api.createRecord('b9d536bc', component.options)
    } else {
      api.reload('b9d536bc', component.options)
    }
    module.hot.accept("./PetsAllowedIconComp.vue?vue&type=template&id=b9d536bc&", function () {
      api.rerender('b9d536bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NzjIhL0ZGxcb/JS/comp/PetsAllowedIconComp.vue"
export default component.exports